export default "__VITE_ASSET__D2J_c5KH__"